export default __webpack_public_path__ + "static/Tuesday-e2217a4ec3d7cac9d636c0997117991d.png";